








































































































import ModalVideoPlayer from "@/components/modal/modalVideoPlayer/ModalVideoPlayer.vue";
import { LoadingStatusType, Position, VideoFeedback } from "@/enums/enums";
import { CheckIsMUZE } from "@/helper/shareHelper";
import { GetYoutubeUrlFromPageName } from "@/helper/youtubeHelper";
import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const IsMUZE = CheckIsMUZE();
const StoreLogIn = namespace("LogIn");
const StoreVideofeedback = namespace("Videofeedback");

@Component({ components: { ModalVideoPlayer } })
export default class VideoPlayer extends Vue {
  isShowVideo = false;
  showModalVideoPlayer = false;
  iframe = "";
  youtubeUrlList: any = [];
  feedbackSelectedChoice: any = {
    notUnderstand: false,
    notSovleIssues: false,
    videoNeedMoreInfo: false,
    videoTooMuchInfo: false,
    other: false,
  };
  feedbackOtherMessage: any = "";
  videoFeedback = VideoFeedback;
  userFeedbackVideo = [];
  isMUZE = IsMUZE;

  @StoreLogIn.Getter
  public getUserModel!: any;
  @StoreLogIn.Getter
  private getMerchant!: SelectedMerchantModel;
  @StoreVideofeedback.Getter
  private getUserFeedbackVideo!: any;
  @StoreVideofeedback.Getter
  private getUserFeedbackVideoLoadingStatus!: LoadingStatusType;
  @StoreVideofeedback.Action
  private DoSendVideoFeedback!: (_input: any) => Promise<boolean>;
  @StoreVideofeedback.Action
  private DoGetVideoFeedback!: (_input: any) => void;
  created() {
    this.SetVideoIframe(this.$route.name);
    this.SetSelectedChoiceDefault();
  }

  @Watch("$route")
  routeChanged(newValue: { name: any }, oldValue: any) {
    this.SetSelectedChoiceDefault();
    this.SetVideoIframe(newValue.name);
  }
  @Watch("$route.query", { immediate: true })
  routeQueryChanged() {
    const { openVideo, videoIndex } = this.$route.query;
    if (openVideo) {
      this.ToggleIsShowVideo(true);
      if (typeof videoIndex === "string") {
        this.$nextTick(() => {
          this.ShowVideo(parseInt(videoIndex));
        });
      }
    }
  }
  @Watch("showModalVideoPlayer")
  showModalVideoPlayerChanged(newValue: any) {
    if (!newValue) {
      this.isShowVideo = true;
    }
  }

  @Watch("getUserFeedbackVideoLoadingStatus")
  getUserFeedbackVideoLoadingStatusChanged(newValue: any) {
    if (newValue === LoadingStatusType.Success) {
      this.SetUserFeedbackVideo();
    }
  }

  public ToggleIsShowVideo(openVideo = false) {
    if (openVideo) {
      this.isShowVideo = !this.isShowVideo;
    } else {
      this.isShowVideo = true;
    }
    if (this.isShowVideo && this.getUserFeedbackVideoLoadingStatus == LoadingStatusType.None) {
      const input = { userId: this.getUserModel.userId, merchantId: this.getMerchant.merchantId };
      this.DoGetVideoFeedback(input);
    }
  }

  public SetVideoIframe(urlName: any) {
    this.youtubeUrlList = GetYoutubeUrlFromPageName(urlName);
    if (this.youtubeUrlList && this.youtubeUrlList.length > 0) {
      this.youtubeUrlList[0].isShow = true;
      this.SetIframe(this.youtubeUrlList[0].url);
      if (this.CheckIsAlreadySendFeedbackVideo(this.youtubeUrlList[0].url)) {
        this.youtubeUrlList[0].isSendFeedback = VideoFeedback.Complete;
      }
    }
  }

  public ShowVideo(youtubeIndexItem: any) {
    this.youtubeUrlList.forEach((youtube: { url: any; isShow: boolean; isSendFeedback: number }, index: any) => {
      youtube.isSendFeedback = VideoFeedback.None;
      if (index == youtubeIndexItem) {
        this.SetIframe(youtube.url);
        youtube.isShow = !youtube.isShow;
        if (this.CheckIsAlreadySendFeedbackVideo(youtube.url)) {
          youtube.isSendFeedback = VideoFeedback.Complete;
        } else {
          this.SetSelectedChoiceDefault();
        }
      } else {
        youtube.isShow = false;
      }
    });
  }

  public SendFeedback(youtubeIndexItem: any, feedbackChoice: number) {
    const currentYoutubeItem = this.youtubeUrlList[youtubeIndexItem];
    const position: any = {
      [Position.BusinessOwner]: this.$t("business_owner"),
      [Position.Bookkeeper]: this.$t("bookkeeper"),
      [Position.Admin]: this.$t("Admin"),
      [Position.Accountant]: this.$t("accountant"),
      [Position.Employee]: this.$t("Employee"),
      [Position.AccountingFirm]: this.$t("Accounting_Firm"),
      [Position.Student]: this.$t("Student"),
      [Position.Other]: this.$t("Other"),
    };
    const user = {
      userId: this.getUserModel.userId,
      userName: this.getUserModel.displayName,
      userPosition: position[this.getUserModel.position],
      userTelephone: this.getUserModel.phone,
    };
    const merchant = {
      merchantId: this.getMerchant.merchantId,
      merchantName: this.getMerchant.merchantName,
    };
    if (feedbackChoice === VideoFeedback.Yes) {
      const input = {
        ...user,
        ...merchant,
        topicName: currentYoutubeItem.name,
        url: currentYoutubeItem.url,
        feedbackUserDetail: [{ key: this.$t("Video_Feedback.Large.Yes"), value: "Checked" }],
      };
      this.DoSendVideoFeedback(input).then((res) => {
        const input = { userId: this.getUserModel.userId, merchantId: this.getMerchant.merchantId };
        this.DoGetVideoFeedback(input);
      });
    } else if (feedbackChoice === VideoFeedback.No) {
      currentYoutubeItem.isSendFeedback = VideoFeedback.No;
    } else if (feedbackChoice === VideoFeedback.Submit) {
      const feedbackOptions = [
        { key: "notUnderstand", textKey: "Not_Understand" },
        { key: "notSovleIssues", textKey: "Not_Sovle_Issues" },
        { key: "videoNeedMoreInfo", textKey: "Video_Need_More_Info" },
        { key: "videoTooMuchInfo", textKey: "Video_Too_Much_Info" },
        { key: "other", textKey: "Other" },
      ];

      const feedbackDetail: any = [];
      feedbackOptions.forEach((option) => {
        if (this.feedbackSelectedChoice[option.key]) {
          feedbackDetail.push({
            key: this.$t(`Video_Feedback.Small.No_Choice.${option.textKey}`),
            value: option.key === "other" ? this.feedbackOtherMessage : "Checked",
          });
        }
      });
      feedbackDetail.push({ key: this.$t("Video_Feedback.Large.No"), value: "Checked" });
      const input = {
        ...user,
        ...merchant,
        topicName: currentYoutubeItem.name,
        url: currentYoutubeItem.url,
        feedbackUserDetail: feedbackDetail,
      };
      this.DoSendVideoFeedback(input).then((res) => {
        const input = { userId: this.getUserModel.userId, merchantId: this.getMerchant.merchantId };
        this.DoGetVideoFeedback(input);
      });
    }
  }

  public SetIframe(url: any) {
    this.iframe = `<iframe width="300" height="168.73" src="${url}" title="YouTube video player" frameborder="0"  clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
  }
  public ShowModalVideoPlayer() {
    this.isShowVideo = false;
    this.showModalVideoPlayer = true;
  }

  public SetUserFeedbackVideo() {
    this.userFeedbackVideo = [];

    if (this.getUserFeedbackVideo.length > 0) {
      this.userFeedbackVideo = this.getUserFeedbackVideo;
    }

    const youtube = this.youtubeUrlList.find((x: any) => x.isShow);
    if (youtube) {
      if (this.CheckIsAlreadySendFeedbackVideo(youtube.url)) {
        youtube.isSendFeedback = VideoFeedback.Complete;
      } else {
        this.SetSelectedChoiceDefault();
      }
    }
  }
  public SetSelectedChoiceDefault() {
    this.feedbackSelectedChoice = {
      notUnderstand: false,
      notSovleIssues: false,
      videoNeedMoreInfo: false,
      videoTooMuchInfo: false,
      other: false,
    };
    this.feedbackOtherMessage = "";
  }

  public CheckIsAlreadySendFeedbackVideo(url: string) {
    return this.getUserFeedbackVideo.filter((feedback: any) => feedback.url === url).length > 0;
  }
}
